export const RITO_LABELS: Record<string, string> = {
  ARBITRIO: 'Arbítrio',
  SUMARIO: 'Sumário',
  SUMARISSIMO: 'Sumaríssimo',
  ORDINARIO: 'Ordinário',
};

export const rotuloRito = (rito: string): string => RITO_LABELS[rito] ?? rito;
